import { getOrganizationLogoForAll, getAllBankName, BankCodesForAll } from '@revenuemarket/bank';
import { Flex } from '@revenuemarket/cds';
import { colorTokens } from '@revenuemarket/design';
import { Alert, Typography } from 'antd';
import Image from 'next/image';

import { useGetWiringAccountList } from '~hooks/queries/wiring/query';
import { useCompanyId } from '~hooks/useCompanyId';
import { css } from '~libs/emotion';

interface Props {
  info: {
    id: number;
    targetPrice: number;
    itemListLength: number;
  };
}

const WiringInfo: React.FC<Props> = ({ info }) => {
  const { companyId } = useCompanyId();
  const { data: accountListData } = useGetWiringAccountList({ companyId });
  const accountList = accountListData?.Data?.data?.items || [];

  const selectedAccount = accountList.find((account) => account.accountId === info.id);
  const validatePrice = info.targetPrice > (selectedAccount?.accountBalance ?? 0);

  if (!selectedAccount) return;

  return (
    <Alert
      banner
      style={{
        background: 'rgba(0, 0, 0, 0.02)',
        padding: '11px 16px',
        borderRadius: 8,
      }}
      className={css`
        & .anticon {
          display: none;
        }
      `}
      description={
        <Flex gap={8} align="center">
          <Flex align="center" gap={8}>
            <Image
              width={16}
              height={16}
              src={
                getOrganizationLogoForAll(selectedAccount?.bankCode as BankCodesForAll)?.x2 ||
                'https://static.clobe.ai/image/etc-bank.png'
              }
              alt={selectedAccount.bankCode}
            />
            <Typography.Text>{`(${getAllBankName(
              selectedAccount.bankCode,
              true,
            )} ${selectedAccount.accountNumber.slice(-4)})`}</Typography.Text>
            <Typography.Text>
              <b>현재 잔액 : {`${(selectedAccount?.accountBalance ?? 0).toLocaleString()}`}원</b>
              {` 에서 총 ${info.itemListLength}건 `}
              <b>{`${Number(info.targetPrice).toLocaleString()}원`}</b> {`을 이체합니다.`}
            </Typography.Text>
          </Flex>
          {validatePrice ? (
            <Typography.Text
              style={{
                color: colorTokens.textDanger,
              }}
            >
              잔액 이내로 금액을 입력해주세요.
            </Typography.Text>
          ) : (
            <div />
          )}
        </Flex>
      }
    />
  );
};

export default WiringInfo;
